import NavListActions from "./actions";

class NavListStoreClass extends NavListActions {}

export default NavListStoreClass;
